/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendLinkEmailRequest
 */
export interface SendLinkEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof SendLinkEmailRequest
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof SendLinkEmailRequest
     */
    subject?: string;
    /**
     * 
     * @type {string}
     * @memberof SendLinkEmailRequest
     */
    text?: string;
}

export function SendLinkEmailRequestFromJSON(json: any): SendLinkEmailRequest {
    return SendLinkEmailRequestFromJSONTyped(json, false);
}

export function SendLinkEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendLinkEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'email': !exists(json, 'email') ? undefined : json['email'],
        'subject': !exists(json, 'subject') ? undefined : json['subject'],
        'text': !exists(json, 'text') ? undefined : json['text'],
    };
}

export function SendLinkEmailRequestToJSON(value?: SendLinkEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'email': value.email,
        'subject': value.subject,
        'text': value.text,
    };
}


